import React from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';

export default function CarouselComponent() {
    return (
        
        <div class="carousel-wrapper">
            <Carousel infiniteLoop useKeyboardArrows autoPlay showStatus={false} showIndicators={false} showThumbs={false} >
                <div>
                    <img src="../fvp.jpg" alt="logo" />
                </div>
                {/* <div>
                    <img src="../fvp_b
                    .
                    0
                    . anner1.jpg" alt="logo" />
                </div>
                <div>
                    <img src="../fvp_banner.jpg" alt="logo" />
                </div> */}
            </Carousel>
            
        </div>
    );
}